import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { apiClient } from "@/api/client"
import { OrderStatus } from "@/api/api-client"

export const useQuoteShipping = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, shippingCost }: { id: number; shippingCost: number }) =>
      apiClient.quoteSubOrderShipping(id, { shippingCost }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendor-orders"] })
      queryClient.invalidateQueries({ queryKey: ["my-orders"] })
    },
  })
}

export const useCreateSubOrderCheckout = () => {
  return useMutation({
    mutationFn: (subOrderId: number) =>
      apiClient.createSubOrderCheckoutSession(subOrderId),
  })
}

export const useVendorOrders = () => {
  return useQuery({
    queryKey: ["vendor-orders"],
    queryFn: () => apiClient.getVendorOrders(),
  })
}

export const useVendorSubOrderHistory = (subOrderId?: number, enabled = false) => {
  return useQuery({
    queryKey: ["vendor-sub-order-history", subOrderId],
    queryFn: () => apiClient.getVendorSubOrderHistory(subOrderId as number),
    enabled: enabled && subOrderId !== undefined,
  })
}

export const useMyOrders = () => {
  return useQuery({
    queryKey: ["my-orders"],
    queryFn: () => apiClient.getMyOrders(),
  })
}

export const useVendorAnalytics = (days: number = 30) => {
  return useQuery({
    queryKey: ["vendor-analytics", days],
    queryFn: () => apiClient.getVendorAnalytics(days),
  })
}

export const useUpdateOrderStatus = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, status }: { id: number; status: OrderStatus }) =>
      apiClient.updateVendorSubOrderStatus(id, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendor-orders"] })
      queryClient.invalidateQueries({ queryKey: ["my-orders"] })
      queryClient.invalidateQueries({ queryKey: ["vendor-analytics"] })
    },
  })
}

